import { call, put, takeLatest } from "redux-saga/effects";

import { authAPI } from "../api/auth.api";
import { Action } from "../../../actions/actions";
import { AuthActionTypes } from "../actions/actionTypes";
import { ToasterService } from "../../../services/toaster/toaster.service";
import { authMessagesStrings } from "../assets/authMessages.strings";
import { loginSignupFailMessages } from "../assets/errorMessages.strings";
import { responseCodePipe } from "../../../services/code_matcher/response_code_pipe.service";

function* newPassword(action: Action) {
    try {
        const data = yield call(authAPI.newPassword, action.payload);

        yield put({
            type: AuthActionTypes.NEW_PASSWORD_SUCCESS,
            payload: data
        });

        yield put({
            type: AuthActionTypes.SHOULD_REDIRECT
        });
    } catch (e) {
        yield put({
            type: AuthActionTypes.NEW_PASSWORD_FAIL,
            error: e.response.data.code
        });
    }
}

export function* newPasswordActionWatcher() {
    yield takeLatest(AuthActionTypes.NEW_PASSWORD, newPassword);
}

function* newPasswordSuccess(_action: Action) {
    ToasterService.successToast(authMessagesStrings.NEW_PASSWORD_SUCCESS);
}

export function* newPasswordSuccessWatcher() {
    yield takeLatest(AuthActionTypes.NEW_PASSWORD_SUCCESS, newPasswordSuccess);
}

function* newPasswordFail(action: Action) {
    ToasterService.errorToast(
        responseCodePipe(action.error, loginSignupFailMessages)
    );
}

export function* newPasswordFailWatcher() {
    yield takeLatest(AuthActionTypes.NEW_PASSWORD_FAIL, newPasswordFail);
}
